/* eslint-disable */
import styled from 'styled-components';
import ThemeHelper from '../../themes/theme-helper';

const ContainerWrapper = styled.div(props => {
    const { palette, typography } = ThemeHelper.getTheme(props);

    let defaultPadding = '20px';
    if (props.zeroPadding) {
        defaultPadding = '0';
    }
    
    return `
    margin: 20px;
    padding: ${defaultPadding};
    border-radius: 5px;
    background-color: #fff;
    box-shadow: 5px 5px rgba(0,0,0,0.07);
    font-family: ${typography.family};
    color: ${palette.primary.dark};
    border: 0px solid #fff;
    `;
});

export { ContainerWrapper };



// WEBPACK FOOTER //
// ./app/components/container/styled.js